import type { AllDayDatum, CalcOptions, OptionsData } from "../algorithm.types";

type CalcOptionsFnParams = {
  optionsData: OptionsData;
  allDayData: Array<AllDayDatum>;
};

export default function calcOptionsFn({
  optionsData,
  allDayData,
}: CalcOptionsFnParams): CalcOptions {
  const dayYearPercent: Array<number> = [];

  for (const dayTypeInfo of allDayData) {
    if (dayTypeInfo.yearPercentage !== null) {
      dayYearPercent.push(+dayTypeInfo.yearPercentage);
    }
  }

  return {
    currencySymb: optionsData.currency,
    minReserveAccep: optionsData.minReserve,
    noOfDayTypes: optionsData.noOfDayTypes,
    noOfSeasons: optionsData.noOfSeasons,
    noOfStorTypes: optionsData.noOfStorTypes,
    noOfTechs: optionsData.noOfTechs,
    noOfTimeSlots: optionsData.noOfTimeSlots,
    timeSlotLabel: optionsData.timeSlotLabels,
    dayYearPercent,
    season: 0,
    dayOfTheSeason: 0,
    noOfDaysPerSeason: optionsData.noOfDayTypes / optionsData.noOfSeasons,
  };
}
